import {
  BackupPolicyType,
  Provider,
  type BackupPolicyConfig,
  type InventoryBackupPolicy,
} from '@repo/api-gw-sdk';

export const isPitrPolicyType = (policyType?: BackupPolicyType) => {
  return (
    policyType === BackupPolicyType.BACKUP_POLICY_TYPE_PITR ||
    policyType === BackupPolicyType.BACKUP_POLICY_TYPE_AWS_NATIVE_PITR ||
    policyType === BackupPolicyType.BACKUP_POLICY_TYPE_BIGQUERY_NATIVE_PITR ||
    policyType ===
      BackupPolicyType.BACKUP_POLICY_TYPE_AZURE_SQL_DATABASE_NATIVE_PITR
  );
};

export const isStandardPolicyType = (policyType?: BackupPolicyType) => {
  return (
    policyType === BackupPolicyType.BACKUP_POLICY_TYPE_STANDARD ||
    policyType === BackupPolicyType.BACKUP_POLICY_TYPE_AWS_NATIVE_STANDARD ||
    policyType === BackupPolicyType.BACKUP_POLICY_TYPE_AZURE_FILES
  );
};

export const isNativePolicyType = (policyType?: BackupPolicyType) => {
  return (
    policyType === BackupPolicyType.BACKUP_POLICY_TYPE_AWS_NATIVE_STANDARD ||
    policyType === BackupPolicyType.BACKUP_POLICY_TYPE_AWS_NATIVE_PITR ||
    policyType === BackupPolicyType.BACKUP_POLICY_TYPE_BIGQUERY_NATIVE_PITR ||
    policyType ===
      BackupPolicyType.BACKUP_POLICY_TYPE_AZURE_SQL_DATABASE_NATIVE_PITR ||
    policyType === BackupPolicyType.BACKUP_POLICY_TYPE_AZURE_FILES
  );
};

export const isContinuousPolicyType = (policyType?: BackupPolicyType) => {
  return (
    policyType === BackupPolicyType.BACKUP_POLICY_TYPE_AWS_NATIVE_PITR ||
    policyType === BackupPolicyType.BACKUP_POLICY_TYPE_BIGQUERY_NATIVE_PITR ||
    policyType ===
      BackupPolicyType.BACKUP_POLICY_TYPE_AZURE_SQL_DATABASE_NATIVE_PITR
  );
};

// backupPolicyNativeProvider resolves the cloud provider used for the
// account-as-vault representation on native policy cards. Each native
// policyType implies a single provider, so the mapping is direct.
export const backupPolicyNativeProvider = (
  policy: BackupPolicyConfig | InventoryBackupPolicy
): Provider => {
  switch (policy.policyType) {
    case BackupPolicyType.BACKUP_POLICY_TYPE_AZURE_FILES:
    case BackupPolicyType.BACKUP_POLICY_TYPE_AZURE_SQL_DATABASE_NATIVE_PITR:
      return Provider.Azure;
    case BackupPolicyType.BACKUP_POLICY_TYPE_BIGQUERY_NATIVE_PITR:
      return Provider.Gcp;
    default:
      return Provider.Aws;
  }
};
